import React, { useState, useContext, useEffect } from "react";
import { Outlet, Link, useNavigate, Navigate } from "react-router-dom";
import { ShareContext } from "../../../context/ShareContext";
import * as Constants from "../../../constants";
import JisButton from "../../controls/jisButton";
import BackLoader from "../../backloader";
import JisDialogForm from "../../formdialog";
import PdfViewer from "../../controls/pdfviewer";

function ViewJudgement({
  caseId,
  caseinfo,
  parties,
  claims,
  motions,
  isAction = false,
}) {
  const [hearingData, setHearingData] = useState({});
  const navigate = useNavigate();
  const { activePage, token, profile, frequentData, setIsExpired } =
    useContext(ShareContext);
  const [loading, setLoading] = useState(false);
  const [mediation, setMediation] = useState(null);
  const [orderTypes, setOrderTypes] = useState([]);
  const [judgementTypes, setJudgementTypes] = useState([]);
  const [pronouncementTypes, setPronouncementTypes] = useState([]);
  const [err, setErr] = useState("");
  const [show, setShow] = useState(true);
     const [isPreview, setIsPreview] = useState(false);
   const [previewUrl, setPreviewUrl] = useState(false);

  useEffect(() => {
    console.log("loading ************************************************");
    console.log(claims);
    onLoadHearing();
    onLoadPronounceType();
    onLoadOrderType();
    onLoadJudgementType();
  }, [caseId]);
  const onLoadHearing = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/hearing/hearing-by-case/${caseId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setShow(true);
        setHearingData({
          hearing: data.hearing,
          motionruling: data.motionruling,
          motionFavours: data.motionFavours,
          claimruling: data.claimruling,
          claimfavour: data.claimfavour,
          notes:data.notes,
        });
        setMediation(data.mediation);
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
        setShow(false);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onLoadPronounceType = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/setup/judgement-setting/pronouce-types`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await resp.json();
      setLoading(false);
      setPronouncementTypes(data.list);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onLoadOrderType = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/setup/judgement-setting/order-types`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await resp.json();
      setLoading(false);
      setOrderTypes(data.list);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onLoadJudgementType = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/setup/judgement-setting/judgement-types`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await resp.json();
      setLoading(false);
      setJudgementTypes(data.list);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
   const onPreviewDoc = (path) => {
      setIsPreview(true);
      console.log(path);
      console.log("here is called");
      var finalpath = "";
      finalpath = Constants.RelativeFiletoRelative(  path
        );
      setPreviewUrl(finalpath);
    };
  return (
    <div>
      {show && (
        <>
          <div className="table">
            <div class="section-cases">
              <span>Hearing(s)</span>
              <span className="total">{hearingData?.hearing?.length}</span>
            </div>
            <table class="case-table">
              <thead>
                <tr>
                  <th className="col-title">Suit Number</th>
                  <th className="col-title">Parties to the Case</th>
                  <th>Date</th>
                  <th>Start Time</th>
                  <th>End Time</th>
                  <th>Judge</th>
                </tr>
              </thead>
              <tbody>
                {hearingData?.hearing?.map((opt, index) => (
                  <tr>
                    <td>{caseinfo?.caseNumber}</td>
                    <td>{caseinfo?.caseTitle}</td>
                    <td>{Constants.displayDate(opt.hearingDate)}</td>
                    <td>{Constants.displayTime(opt.startTime)}</td>
                    <td>{Constants.displayTime(opt.endTime)}</td>
                    <td>{Constants.judgeName(opt.createdBy)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="table">
            <div class="section-cases">
              <span>Motions Ruling(s)</span>
              <span className="total">{hearingData?.motionruling?.length}</span>
            </div>
            <table class="case-table">
              <thead>
                <tr>
                  <th className="col-title">Prayer(s)</th>
                  <th className="col-medium">Ruling Date</th>
                  <th>Judge</th>
                  <th className="col-id">Order</th>
                  <th>In Favour</th>
                  <th>Doc</th>
                </tr>
              </thead>
              <tbody>
                {hearingData?.motionruling?.map((opt, index) => (
                  <tr>
                    <td>
                      <div>
                        {motions
                          .find((d) => d.id == opt.motionId)
                          ?.prayers?.filter((e) => e.motionRulingId == opt.id)
                          .map((pray, index) => (
                            <div key={pray.id} className="selected-disabled">
                              {" "}
                              {pray.prayer}
                            </div>
                          ))}
                      </div>
                    </td>
                    <td>{Constants.momentDate(opt.orderGivenOn).format(  "DD MMM, YYYY")}</td>
                    <td>{Constants.judgeName(opt.createdBy)}</td>
                    <td>
                      {orderTypes?.find((d) => d.id == opt.orderTypeId)?.title}
                    </td>
                    <td>
                      In faovur of
                      {hearingData?.motionFavours
                        ?.filter((e) => e.motionRulingId == opt.id)
                        .map((favour, index) => {
                          const p = parties?.find(
                            (d) => d.id === favour.partyId
                          );
                          return (
                            <div key={favour.id} className="selected-disabled">
                              {p?.firstName} {p?.lastName ?? ""}
                            </div>
                          );
                        })}
                    </td>
                     <td>
                      {opt.uploadedDoc!=null && <JisButton
                      variant="plain"
                      onClick={() => onPreviewDoc(opt.uploadedDoc)}
                    >
                      Preview
                    </JisButton>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="table">
            <div class="section-cases">
              <span>Judgement(s)</span>
              <span className="total">{hearingData?.claimruling?.length}</span>
            </div>
            <table class="case-table">
              <thead>
                <tr>
                  <th className="col-title">Claim/Offence</th>
                  <th className="col-title">Pronouncement</th>
                  <th>Favour</th>
                  <th className="col-medium">Date Pronounced</th>
                  <th className="col-title">Other Details</th>
                </tr>
              </thead>
              <tbody>
                {hearingData?.claimruling?.map((opt, index) => (
                  <tr>
                    <td>{claims.find((d) => d.rulingId == opt.id)?.claim}</td>
                    <td>
                      {
                        pronouncementTypes?.find(
                          (d) => d.id == opt.pronounceTypeId
                        )?.title
                      }
                    </td>
                    <td>
                      In favour of
                      {hearingData?.claimfavour
                        ?.filter((e) => e.claimRulingId == opt.id)
                        .map((favour, index) => {
                          const p = parties?.find(
                            (d) => d.id === favour.partyId
                          );
                          return (
                            <div key={favour.id} className="selected-disabled">
                              {p?.firstName} {p?.lastName ?? ""}
                            </div>
                          );
                        })}
                    </td>
                    <td> {Constants.momentDate(opt.orderGivenOn).format(  "DD MMM, YYYY")}</td>
                    <td>
                      {opt.grantedAmount != null && (
                        <div className="selected-disabled">
                          <div className="label-value">
                            <span className="label">Amount Granted</span>
                            <span className="value">
                              {Constants.formatCurrency(opt.grantedAmount)}
                            </span>
                          </div>
                        </div>
                      )}
                      {opt.interestType != "" && (
                        <div className="selected-disabled">
                          <div className="label-value">
                            <span className="label">Interest</span>
                            <span className="value">{opt.interestType}</span>
                          </div>
                        </div>
                      )}
                      {opt.rate != null && (
                        <div className="selected-disabled">
                          <div className="label-value">
                            <span className="label">Rate</span>
                            <span className="value">{opt.rate}%</span>
                          </div>
                        </div>
                      )}
                      {opt.interestFrom != null && (
                        <div className="selected-disabled">
                          <div className="label-value">
                            <span className="label">Interest From</span>
                            <span className="value">{opt.interestFrom}</span>
                          </div>
                        </div>
                      )}
                      {opt.sentenceDurationType != null && (
                        <div className="selected-disabled">
                          <div className="label-value">
                            <span className="label">Sentence</span>
                            <span className="value">
                              {opt.sentenceDuration}
                              {opt.sentenceDurationType}(s)
                            </span>
                          </div>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="table">
            <div class="section-cases">
              <span>Judges Note(s)</span>
              <span className="total">{hearingData?.notes?.length}</span>
            </div>
            <table class="case-table">
              <thead>
                <tr>
                  
                  <th className="col-medium">Ruling Date</th>
                  <th>Judge</th>
                  <th className="col-id">Note</th>
                
                </tr>
              </thead>
              <tbody>
                {hearingData?.notes?.map((opt, index) => (
                  <tr>
                    
                    <td>{Constants.momentDate(opt.createdOn).format(  "DD MMM, YYYY")}</td>
                    <td> {Constants.judgeName(opt.createdBy)}</td>
                    <td>
                      {opt.uploadDoc==null?opt.note:<JisButton
                      variant="plain"
                      onClick={() => onPreviewDoc(opt.uploadDoc)}
                    >
                      Preview
                    </JisButton>}
                    </td>
                     
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
      {!show && <p className="error">{err}</p>}
      <BackLoader open={loading} />
      {isPreview && previewUrl != "" && (
        <JisDialogForm
          title="Document Preview"
          onClose={() => setIsPreview(false)}
        >
          <div>
            <div style={{ height: "90vh" }}>
              {" "}
              <PdfViewer pdfUrl={previewUrl} />
            </div>
          </div>
        </JisDialogForm>
      )}
    </div>
  );
}

export default ViewJudgement;
